import { render, staticRenderFns } from "./editContractFlaForm.vue?vue&type=template&id=8f879b70&"
import script from "./editContractFlaForm.vue?vue&type=script&lang=js&"
export * from "./editContractFlaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports